import { Button, Popconfirm, Tag, Space, Tooltip } from "antd"
import { withRouter, Link } from "react-router-dom"
import ClosedSupport from "./ClosedSupport"
import {
  SendOutlined,
  EyeOutlined,
  FileTextOutlined,
  LockOutlined,
  UnlockOutlined,
} from "@ant-design/icons"
import { SupportFiles } from "./SupportFiles"

export const renderSupportMessageButton = (params, { props }) => {
  return (
    <Link to={`/support/${params.id}`}>
      <Button type="link" icon={<EyeOutlined />} size="small">
        {params.ticketNumber}
      </Button>
    </Link>
  )
}

export const renderClosedSupportButton = (params, { props }) => {
  return <ClosedSupport rowData={params} mainProps={props} />
}

export const renderSwitchSupportButton = (params, { props }, toRole) => {
  const roleNames = {
    admin2: "مدیریت",
    admin: "معاونت",
    Accountant: "حسابداری",
    Engineer: "کارشناس",
    Executor: "مجری",
  }

  return (
    <Popconfirm
      title="ارجاع تیکت"
      description={`تیکت به ${roleNames[toRole]} ارجاع خواهد شد`}
      onConfirm={() =>
        props.onSwitchSupport({
          supportId: params.id,
          toRole:
            toRole === "admin" || toRole === "admin2"
              ? "Administrator"
              : toRole,
        })
      }
      okText="تأیید"
      cancelText="انصراف"
    >
      <Tooltip title={`ارجاع به ${roleNames[toRole]}`}>
        <Button icon={<SendOutlined />} size="small" type="primary" ghost />
      </Tooltip>
    </Popconfirm>
  )
}
export const renderFileButton = (row, { props, setErrorMessage }) => {
  return (
    <Tooltip title="مدیریت فایل‌ها">
      <SupportFiles
        rowData={row}
        mainProps={props}
        setErrorMessage={setErrorMessage}
      />
    </Tooltip>
  )
}
export const columns = props =>
  [
    {
      title: "شماره تیکت",
      key: "actions",
      fixed: "left",
      width: "10rem",
      render: row => (
        <Space size="small">
          {renderSupportMessageButton(row, props)}
          {renderFileButton(row, props)}
        </Space>
      ),
    },
    {
      title: "وضعیت",
      children: [
        {
          title: "خوانده شده",
          key: "isRead",
          render: record => (
            <Tag color={record.isRead ? "green" : "orange"} size="small">
              {record.isRead ? "بله" : "خیر"}
            </Tag>
          ),
          width: "6rem",
        },
        {
          title: "باز/بسته",
          key: "closed",
          render: record => (
            <Tag
              icon={record.closed ? <LockOutlined /> : <UnlockOutlined />}
              color={record.closed ? "red" : "green"}
              size="small"
            >
              {record.closed ? "بسته" : "باز"}
            </Tag>
          ),
          width: "6rem",
        },
      ],
    },
    {
      title: "ارجاع",
      children: [
        {
          title: "معاونت",
          key: "switchToAdmin",
          render: row => renderSwitchSupportButton(row, props, "admin"),
          width: "5rem",
          hidden:
            props.currentUser.nameid === "admin" ||
            props.currentUser.role === "Executor" ||
            props.currentUser.role === "Engineer",
        },
        {
          title: "مدیریت",
          key: "switchToAdmin",
          render: row => renderSwitchSupportButton(row, props, "admin2"),
          width: "5rem",
          hidden:
            props.currentUser.nameid === "admin2" ||
            props.currentUser.role === "Executor" ||
            props.currentUser.role === "Engineer",
        },
        {
          title: "حسابداری",
          key: "switchToAccountant",
          render: row => renderSwitchSupportButton(row, props, "Accountant"),
          width: "5rem",
          hidden:
            props.currentUser.role === "Accountant" ||
            props.currentUser.role === "Executor" ||
            props.currentUser.role === "Engineer",
        },
      ],
    },
    {
      title: "اطلاعات تیکت",
      children: [
        {
          title: "شماره پرونده",
          key: "fileNumbers",
          render: row => {
            const { fileNumbers, fileNumber } = row
            if (
              !fileNumbers ||
              fileNumbers.length === 0 ||
              (fileNumbers.length === 1 && fileNumber[0] === null)
            ) {
              return fileNumber ? (
                <Tag color="blue">{fileNumber}</Tag>
              ) : (
                <Tag>ندارد</Tag>
              )
            }

            // If it's a string (comma-separated), split it
            const numbers =
              typeof fileNumbers === "string"
                ? fileNumbers.split(",").filter(n => n.trim())
                : fileNumbers

            if (numbers.length === 1) {
              return <Tag color="blue">{numbers[0]}</Tag>
            }

            // Show first file number and count
            return (
              <Tooltip title={numbers.join(", ")} placement="topLeft">
                <Space size="small">
                  <Tag color="blue">{numbers[0]}</Tag>
                  {numbers.length > 1 && (
                    <Tag color="cyan">+{numbers.length - 1}</Tag>
                  )}
                </Space>
              </Tooltip>
            )
          },
          filters: props.fileNumberFilter,
          filterSearch: true,
          onFilter: (value, record) => {
            const numbers =
              typeof record.fileNumbers === "string"
                ? record.fileNumbers.split(",").filter(n => n.trim())
                : record.fileNumbers || []
            return numbers.some(num => num.toString().includes(value))
          },
          width: "10rem",
        },
        {
          title: "موضوع",
          key: "title",
          render: row => (
            <Tooltip title={row.title} placement="topLeft">
              <div
                style={{
                  fontWeight: row.isRead ? "normal" : "bold",
                  color: row.isRead ? "#666" : "#1890ff",
                  cursor: "pointer",
                }}
              >
                {row.title?.length > 50
                  ? row.title.slice(0, 50) + "..."
                  : row.title}
              </div>
            </Tooltip>
          ),
          width: "20rem",
          ellipsis: {
            showTitle: false,
          },
        },
      ],
    },
    {
      title: "کاربران",
      children: [
        {
          title: "نوع کاربر",
          key: "userTypeName",
          dataIndex: "userTypeName",
          width: "6rem",
          hidden:
            props.currentUser.role === "Employee" ||
            props.currentUser.role === "Executor" ||
            props.currentUser.role === "Engineer",
        },
        {
          title: "از طرف",
          key: "name",
          dataIndex: "name",
          width: "8rem",
          ellipsis: true,
        },
        {
          title: "به",
          key: "toName",
          dataIndex: "toName",
          width: "8rem",
          ellipsis: true,
        },
      ],
    },
    {
      title: "تاریخ",
      children: [
        {
          title: "ایجاد",
          key: "solarCreate",
          dataIndex: "solarCreate",
          width: "7rem",
          sorter: (a, b) => new Date(a.solarCreate) - new Date(b.solarCreate),
        },
        {
          title: "بسته شدن",
          key: "solarEndSupport",
          dataIndex: "solarEndSupport",
          width: "7rem",
          render: text => text || "-",
        },
      ],
    },
    {
      title: "مدیریت",
      key: "management",
      fixed: "right",
      width: "6rem",
      render: row => renderClosedSupportButton(row, props),
      hidden:
        props.currentUser.role === "Engineer" ||
        props.currentUser.role == "Executor",
    },
  ].filter(col => {
    // Filter out hidden columns and their children
    if (col.hidden) return false
    if (col.children) {
      col.children = col.children.filter(child => !child.hidden)
      return col.children?.length > 0
    }
    return true
  })
